/**
 * Customer Portal Configuration
 *
 * All customer portal pages are mounted under this base path.
 * Staff POS routes use "/" while customer routes use "/customer".
 */

export const CUSTOMER_BASE = '/customer';

/**
 * Build a customer portal path.
 * customerPath('/login') → '/customer/login'
 * customerPath('/') → '/customer'
 */
export function customerPath(path: string): string {
  if (path === '/') return CUSTOMER_BASE;
  return `${CUSTOMER_BASE}${path}`;
}
